export default "__VITE_ASSET__CQgw23$M__"